module.exports = __webpack_public_path__ + "static/fonts/iconfont.7dd01a6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/openSurvey/theme/fonts/iconfont.ttf
// module id = pbKg
// module chunks = 1